module.exports = __webpack_public_path__ + "static/hunter-c35a06287f90e7020f4f1f46dcb7d90c.png";